// Module
var code = "<label class=\"slide-toggle-container\"><input id=\"{{$ctrl.id}}\" type=\"checkbox\" class=\"slide-toggle-input\" ng-model=\"$ctrl.value\" ng-change=\"$ctrl.onChange()\" ng-disabled=\"!!$ctrl.disabled\" aria-label=\"{{$ctrl.ariaLabel}}\" tabindex=\"-1\"/><slide-toggle-thumb ng-disabled=\"!!$ctrl.disabled\"></slide-toggle-thumb></label>";
// Exports
module.exports = code;